/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { useParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import PropTypes from "prop-types";
import { WarningPopUp, Image } from "hesus-ui-kit";
import editIcon from "@icons/ic-edit-blue.svg";
import deleteIcon from "@icons/ic-delete-red.svg";
import cancelIcon from "@icons/ic-cancel.svg";
import { GridRow, ButtonWrapper } from "../../EnquiryView.styled";
import AddEditEnquiry from "../../../AddEditEnquiry";
import {
  Separator,
  BreadCrumb,
  ButtonData,
  ActionButtonDiv,
  ProductTitle,
} from "./Header.styled";
import "./Header.scss";

const Header = (props) => {
  const {
    t,
    enquiryData,
    setEnquiryData,
    setIsRefeshData,
    updateRefeshStatus,
  } = props;
  const params = useParams();
  const history = useNavigate();
  const [communicationBox, setCommunicationBox] = useState(false);

  const [isSyncRunning, setIsSyncingRunning] = useState(false);
  const [isAddEnquiryPopupVisible, setAddEnquiryPopupVisible] = useState(false);

  const [isConfirmVisible, setConfirmVisibility] = useState(false);

  const [confirmationBoxTitle, setConfirmationBoxTitle] = useState("");
  const [confirmationBoxContent, setConfirmationBoxContent] = useState("");

  const stepData = {
    1: {
      label: "ENQUIRY_STATUS_TO_PROCESS",
      color: "#0A4986",
    },
    2: {
      label: "ENQUIRY_STATUS_QUOTATION",
      color: "#F08046",
    },

    4: {
      label: "ENQUIRY_STATUS_DELETED",
      color: "#E83F1E",
    },

    6: {
      label: "ENQUIRY_STATUS_CANCELED",
      color: "#CCCCCC",
    },

    5: {
      label: "ENQUIRY_STATUS_QUOTED",
      color: "#32A728",
    },

    9: {
      label: "ENQUIRY_STATUS_REQUOTATION",
      color: "#F08046",
    },
  };

  const openCommunicationBox = () => {
    setCommunicationBox(true);
  };
  const onCommunicationBoxCancel = () => {
    setCommunicationBox(false);
  };
  const onEdit = () => {
    setAddEnquiryPopupVisible(true);
  };
  const closeEnquiryCreationPopup = () => {
    setAddEnquiryPopupVisible(false);
  };

  const handleEnquiryStep = (toStatus) => {
    if (toStatus === 6) {
      setConfirmationBoxTitle("ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "ENQUIRY_CANCEL_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    } else {
      setConfirmationBoxTitle("ENQUIRY_DELETE_CONFIRMATION_BOX_DELETE");
      setConfirmationBoxContent(
        "ENQUIRY_DELETE_CONFIRMATION_BOX_DELETE_CONTENT"
      );
    }
    setConfirmVisibility(true);
  };

  const updateSiteStep = () => {
    const jsonData = {
      previousStepId: enquiryData.step,
      newStepId: enquiryData.step === 6 ? 4 : 6,
    };
    setIsSyncingRunning(true);
    axios
      .post(`/enquiries/${enquiryData.id}/transitionStep`, jsonData)
      .then((response) => {
        setIsDisplayMore(false);
        setEnquiryData(response?.data[0]);
        setIsSyncingRunning(false);
        setIsRefeshData(true);
      })
      .catch((error) => handleApiError(error));
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
  };

  const onPopUpConfirm = () => {
    updateSiteStep();
    setConfirmVisibility(false);
  };

  return (
    <>
      <Separator></Separator>
      <GridRow column="1fr" marginBottom="0px">
        <BreadCrumb>
          <Link
            to={`/site/view/${enquiryData.site.id}/enquiry`}
            className="enquiry-view-header__link"
          >
            {"<"}
            {t("GENERAL_BACK_TO_LIST")}
          </Link>
        </BreadCrumb>
      </GridRow>
      <GridRow column="1fr 1fr">
        <div>
          <ProductTitle>
            #
            {enquiryData.id +
              " - " +
              t(enquiryData?.subCategory?.name) +
              " - " +
              enquiryData?.product?.name}
          </ProductTitle>
          <GridRow column="1fr">
            <div>
              {enquiryData.serviceType === "EVACUATION" && (
                <ButtonData color="#32A728" marginRight="10px">
                  {t("PRODUCTS_FILTER_REMOVAL")}
                </ButtonData>
              )}

              {enquiryData.serviceType === "DELIVERY" && (
                <ButtonData marginRight="10px" color="#0A4986">
                  {t("PRODUCTS_FILTER_SUPPLY")}
                </ButtonData>
              )}
              {enquiryData.serviceType === "NONE" && (
                <ButtonData marginRight="10px" color="#32A728">
                  {t("PRODUCTS_FILTER_OTHER")}
                </ButtonData>
              )}
              {enquiryData.isTender === true && (
                <ButtonData color="#F08046" marginRight="10px">
                  {t("SITE_TYPE_TENDER")}
                </ButtonData>
              )}
              {enquiryData.isTender !== true && (
                <ButtonData color="#00AEEA" marginRight="10px">
                  {t("SITE_TYPE_LIVE")}
                </ButtonData>
              )}
            </div>
          </GridRow>
        </div>

        <ButtonWrapper>
          <ActionButtonDiv>
            {[1, 2, 5, 9].includes(enquiryData.step) && (
              <Image
                src={editIcon}
                alt={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
                title={t("ENQUIRY_ACTION_TOOLTIP_EDIT")}
                className="enquiry-view-header__image-icon"
                onClick={onEdit}
              />
            )}
            {enquiryData.step === 6 && (
              <Image
                src={deleteIcon}
                alt={t("ENQUIRY_ACTION_TOOLTIP_DISABLE")}
                title={t("ENQUIRY_ACTION_TOOLTIP_DISABLE")}
                className="enquiry-view-header__image-icon"
                onClick={() => handleEnquiryStep(4)}
              />
            )}
            {[1, 2].includes(enquiryData.step) && (
              <Image
                src={cancelIcon}
                alt={t("ENQUIRY_ACTION_TOOLTIP_CANCEL")}
                title={t("ENQUIRY_ACTION_TOOLTIP_CANCEL")}
                className="enquiry-view-header__image-icon"
                onClick={() => handleEnquiryStep(6)}
              />
            )}
          </ActionButtonDiv>
          <GridRow>
            <div>
              <ButtonData color={stepData[enquiryData.step].color}>
                {t(stepData[enquiryData.step].label)}
              </ButtonData>
            </div>
          </GridRow>
        </ButtonWrapper>
      </GridRow>

      {isAddEnquiryPopupVisible && (
        <AddEditEnquiry
          title={t("ENQUIRY")}
          onClose={closeEnquiryCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
          siteId={params.id}
          platformCountryId={enquiryData?.site?.platformCountry?.id}
          enquiryData={enquiryData}
          id={enquiryData.id}
          isEditMode
        />
      )}
      {isConfirmVisible && (
        <WarningPopUp
          title={t(confirmationBoxTitle)}
          message={t(confirmationBoxContent)}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </>
  );
};

Header.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(Header);
